const HelpButton = ({ helpOpen, setHelpOpen, device, setSelectedDevice }) => {

    const handleClick = (event) => {
        setHelpOpen(!helpOpen)
        setSelectedDevice(device)
    };

    return (
        <div className="flex h-[30px] !w-[30px] p-0 items-center cursor-pointer justify-center rounded-full border border-solid border-gray_light" onClick={handleClick}>
            <img className="h-[20px]" src={process.env.REACT_APP_ASSETSDIR + 'help.png'} alt=""></img>
        </div>
    );
}
export default HelpButton;
